












import { Component, Vue, Prop } from "vue-property-decorator";
import { clamp } from "@/domainproject/helpers";

@Component({
  watch: {
    value: function(this: PowerSlider) {
      this.updateCanvas();
    },
    mousedown: function(this: PowerSlider) {
      this.updateCanvas();
    },
    color: function(this: PowerSlider) {
      this.updateCanvas();
    },
    inv: function(this: PowerSlider) {
      this.updateCanvas();
    }
  }
})
export default class PowerSlider extends Vue {
  @Prop() color!: string;
  @Prop() inv!: boolean;
  @Prop() initialPower!: number;

  value = 0.5;
  min = 0.1;

  mousedown = false;
  initial = true;

  get canvas(): HTMLCanvasElement {
    return this.$refs["canvas"] as HTMLCanvasElement;
  }

  mousemove(event: MouseEvent) {
    if (!this.mousedown) return;
    const x = clamp(event.offsetX / this.canvas.width, this.min, 1 - this.min);
    const yPos = event.offsetY / this.canvas.height;
    const y = clamp(this.inv ? yPos : 1 - yPos, this.min, 1 - this.min);

    const power = Math.log(y) / Math.log(x);

    this.value = Math.pow(0.5, 1 / power);
  }

  mouseup() {
    this.mousedown = false;
  }

  mounted() {
    this.value = Math.pow(0.5, 1 / this.initialPower);
    document.body.addEventListener("mouseup", this.mouseup, false);
    this.initial = true;
    this.updateCanvas();
    this.initial = false;
  }

  destroyed() {
    document.body.removeEventListener("mouseup", this.mouseup, false);
  }

  updateCanvas() {
    const ctx = this.canvas.getContext("2d")!;
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    ctx.fillStyle = this.color;
    ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

    const power = Math.log(0.5) / Math.log(this.value);

    let fn = (x: number) => (this.inv ? 1 - x ** power : x ** power);
    if (!this.mousedown && !this.initial) this.$emit("power", power);

    ctx.strokeStyle = this.mousedown ? "#12053266" : "#120532";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(0, this.canvas.height);
    for (let x = 0; x < this.canvas.width; x++) {
      ctx.lineTo(
        x,
        this.canvas.height - fn(x / this.canvas.width) * this.canvas.height
      );
    }
    ctx.lineTo(this.canvas.width, 0);

    ctx.stroke();
  }
}
